import { Fragment, Suspense, useMemo } from 'react';
import CircularProgress from '@zeptonow/zui/CircularProgress';
import { defaultColors as colors } from '@zeptonow/zui';
import { Routes, Route, useLocation } from 'react-router-dom';
import { RenderModuleRoutesInterface } from './types';
import { RouteConstants } from '../constants/routes';
import PageNotFoundView from '../views/PageNotFound';
import getModuleRoutes from './ModuleRoutes';
import ProtectedRoute from './ProtectedRoute';
import RedirectRoute from './RedirectRoute';
import { RenderGlobalRoutesInterface } from './types';
import GlobalRoutes from './GlobalRoutes';

const renderModuleRoutes: RenderModuleRoutesInterface = (routes) => {
  if (!routes || !routes.length) return null;
  return routes.map((route) => {
    const Component = route.component;
    const { id, route: path } = route;
    return (
      <Fragment key={id}>
        {renderModuleRoutes(route.children)}
        <Route
          path={path}
          element={
            <ProtectedRoute moduleId={id}>
              {Component && <Component />}
            </ProtectedRoute>
          }
        />
      </Fragment>
    );
  });
};

const renderGlobalRoutes: RenderGlobalRoutesInterface = (routes) => {
  return routes?.map((route, index) => {
    const Component = route.component;
    const { route: path } = route;
    return (
      <Route
        key={index}
        path={path}
        element={<RedirectRoute>{Component && <Component />}</RedirectRoute>}
      />
    );
  });
};

const AppRoutes = () => {
  const { pathname } = useLocation();

  const moduleRoutes = useMemo(() => {
    return getModuleRoutes(pathname);
  }, [pathname]);

  return (
    <Suspense
      fallback={
        <div className="relative h-[calc(100vh-4rem)] z-0">
          <CircularProgress
            isOpen
            isBackdropVisible
            color={colors.primary[800]}
            className="!absolute !bg-[rgba(50,50,50,0.25)]"
          />
        </div>
      }
    >
      <Routes>
        {renderModuleRoutes(moduleRoutes)}
        {renderGlobalRoutes(GlobalRoutes)}
        <Route path={RouteConstants.NOT_FOUND} element={<PageNotFoundView />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
